function modelisations() {
  let initialCSS = $('.plan-container').css('background-image');

  $('.plan-container .pulse-icon').on('click', function() {
    let category = $(this).attr('data-category');
    $('.category-info[data-category!='+ category +']').addClass('hide');
    $('.category-info[data-category='+ category +']').removeClass('hide');

    if ($(this).attr('data-img') !== '') {
      $('.plan-overlay').css('background-image', 'url('+ $(this).attr('data-img') +')');
    } else {
      $('.plan-overlay').css('background-image', 'none');
    }

    $('html, body').animate({
      scrollTop: $('.category-header').offset().top - $('.header-top').height() - 50
    }, 1000);
  });

  $('.category-info--back').on('click', function() {
    $('.category-info').removeClass('hide');
    $('.category-info[data-category]').addClass('hide');
    $('.plan-overlay').css('background-image', 'none');

    $('html, body').animate({
      scrollTop: $('.category-header').offset().top - $('.header-top').height() - 50
    }, 1000);
  });
}

export { modelisations };
